// MovieDetailFilter helper functions and data

import { BasicInternationalization } from "types/common.types";

export const getMovieFilters = (
  t: BasicInternationalization,
  language: string | undefined,
  languages: string[],
  theaterTypesName: string[],
  format: string | undefined,
  room: string | undefined,
  option: string[]
) => [
  {
    defaultValue: t.movie.allLanguages,
    options: [t.movie.allLanguages, ...languages],
    eventName: "language",
    value: language
  },
  {
    defaultValue: t.movie.allFormats,
    options: [t.movie.allFormats, ...option],
    eventName: "format",
    value: format
  },
  {
    defaultValue: t.movie.allRooms,
    options: [t.movie.allRooms, ...theaterTypesName],
    eventName: "room",
    value: room
  }
];
